export default {
    '$route': function() {
        const self = this

        self.banner = {}
        self.resetFormResult()
    }
}
